import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCSearchBankComponent = class UiCSearchBankComponent {
    constructor() {
        this.clickEvt = new EventEmitter();
        this.dismiss = new EventEmitter();
    }
    ngOnInit() { }
    filterListBank(value) {
        if (value === undefined || value === '') {
            this.banksFilter = this.bankList;
        }
        else {
            this.banksFilter = this.bankList.filter((unit) => (unit.code + ' - ' + unit.name.normalize("NFD").replace(/[^a-zA-Z0-9s]/g, "").toUpperCase()).indexOf(value.normalize("NFD").replace(/[^a-zA-Z0-9s]/g, "").toUpperCase()) > -1);
        }
    }
    selectBank(item) {
        this.clickEvt.emit(item);
    }
    dismissModal() {
        this.dismiss.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCSearchBankComponent.prototype, "bankList", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCSearchBankComponent.prototype, "banksFilter", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCSearchBankComponent.prototype, "clickEvt", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCSearchBankComponent.prototype, "dismiss", void 0);
UiCSearchBankComponent = __decorate([
    Component({
        selector: 'ui-c-search-bank',
        template: "<div class=\"search-bank-component\">\n  <ion-header translucent>\n    <ion-toolbar>\n      <ion-title>\n        {{'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BANK.SEARCH_BANK.TITLE' | wlpTranslate}}\n      </ion-title>\n      <ion-buttons slot=\"end\">\n        <ion-button (click)=\"dismissModal()\">\n          {{'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BANK.SEARCH_BANK.CLOSE_BUTTON' | wlpTranslate}}\n        </ion-button>\n      </ion-buttons>\n    </ion-toolbar>\n  </ion-header>\n  <ion-row class=\"w100\">\n    <ion-col class=\"ion-padding-horizontal\" size=\"12\">\n      <div class=\"search\">\n        <ion-searchbar placeholder=\"{{'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BANK.SEARCH_BANK.PLACEHOLDER' | wlpTranslate}}\"\n          (keyup)=\"filterListBank($event.target.value)\"></ion-searchbar>\n      </div>\n      <div class=\"ion-card\">\n        <ion-content [scrollEvents]=\"true\">\n          <ion-list *ngFor=\"let item of banksFilter\">\n            <ion-item (click)=\"selectBank(item)\">\n              <ion-label class=\"text-left\">{{item.code}} - {{item.name}}</ion-label>\n            </ion-item>\n          </ion-list>\n        </ion-content>\n      </div>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCSearchBankComponent);

let UiCSearchBankModule = class UiCSearchBankModule {
};
UiCSearchBankModule = __decorate([
    NgModule({
        declarations: [UiCSearchBankComponent],
        imports: [
            IonicModule,
            CommonModule,
            ReactiveFormsModule,
            UiCButtonModule,
            UiBsTranslateModule,
        ],
        exports: [UiCSearchBankComponent]
    })
], UiCSearchBankModule);

export { UiCSearchBankComponent, UiCSearchBankModule };
//# sourceMappingURL=wlp-ui-c-search-bank.js.map
